import { TEMPLATE_STATUS } from '../../../constants/messageTemplateKeys';

export function normalizeStatusKey(value) {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
  return normalized || TEMPLATE_STATUS.DRAFT;
}
